// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_CNB","cls2":"CoScientistPricingPage-cls2_R6O CoScientistPricingPage-cls1_CNB"};